// extracted by mini-css-extract-plugin
export default {"row":"rfQO6hgPw4k49Hz1qBA_","label":"yGzO4VXQQ_uTW2YbfFEN","wrapped":"mGORGCjk9HiDpjl6hMnu","bold":"SMvg5jgHYLE0dcSRcZPv","subtitle":"sSp_EvAoPfkItC_cTmT2"};